module.exports = __webpack_public_path__ + "static/media/SP_S_Neutral.79693db5.png";